import { render, staticRenderFns } from "./MessageListPreferencesModal.vue?vue&type=template&id=b6f52e94&scoped=true&"
import script from "./MessageListPreferencesModal.vue?vue&type=script&lang=js&"
export * from "./MessageListPreferencesModal.vue?vue&type=script&lang=js&"
import style0 from "./MessageListPreferencesModal.vue?vue&type=style&index=0&id=b6f52e94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f52e94",
  null
  
)

export default component.exports